<template>
  <ul class="recipe-list-item__meta inline" v-if="hasMeta">
    <li class="recipe-list-item__meta-item recipeYield" v-if="recipeYield" v-html="recipeYieldAsString"></li>
    <li class="recipe-list-item__meta-item prepTime" v-if="prepTime">
      <h4>Preparation</h4> {{ humanizedPrepTime }}
    </li>
    <li class="recipe-list-item__meta-item prepTime" v-if="cookTime">
      <h4>Cook</h4> {{ humanizedCookTime }}
    </li>
    <li class="recipe-list-item__meta-item adaptedFrom" v-if="url">
      <h4>Adapted from</h4> <a :href="url" :title="'View original on ' + domain" target="_blank">{{domain}}</a>
    </li>
  </ul>
</template>

<script>
import humanizeDuration from 'humanize-duration'
const yieldPhraseRegex = /(Makes|Serves|Yields|servings)/
const shortHumanizeDuration = humanizeDuration.humanizer({
  delimiter: ' ',
  language: 'shortEn',
  languages: {
    shortEn: {
      y: function () { return 'y' },
      mo: function () { return 'mo' },
      w: function () { return 'w' },
      d: function () { return 'd' },
      h: function () { return 'h' },
      m: function () { return 'm' },
      s: function () { return 's' },
      ms: function () { return 'ms' }
    }
  },
  spacer: ''
})
export default {
  name: 'RecipeMeta',
  props: [
    'cookTime',
    'domain',
    'prepTime',
    'preheatTemperature',
    'recipeYield',
    'url'
  ],
  computed: {
    hasMeta () {
      return this.prepTime ||
        this.recipeYield ||
        this.preheatTemperature ||
        this.domain
    },
    humanizedCookTime () {
      return shortHumanizeDuration(this.cookTime * 60000)
    },
    humanizedPrepTime () {
      return shortHumanizeDuration(this.prepTime * 60000)
    },
    recipeYieldAsString () {
      if (/[A-Za-z]/.test(this.recipeYield)) {
        return this.recipeYield.replace(yieldPhraseRegex, '<h4>$1</h4>')
      }
      return `<h4>Serves</h4> ${this.recipeYield}`
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.recipe-list-item__meta
  width: 100%
  line-height: $layoutLineHeight
  .recipe-list-item__meta-item
    color: #1d2127
    font-weight: 500
    margin: 0!important
    padding: 0 8px 0 0
    display: inline-block
    list-style: none
    h4
      font-family: $bodyFontFamily
      line-height: inherit
      margin-bottom: 0
      color: $subtleTextColor
      font-weight: 400
    a
      color: $textColor
  .label
    display: block
    color: rgba(0, 0, 0, 0.54)
    font-size: 16px
  &.inline
    margin-top: 0
    margin-bottom: 0
    padding: 0
    h4
      display: inline-block
      margin-top: 0
    .recipe-list-item__meta-item
      width: auto
</style>



// WEBPACK FOOTER //
// src/components/RecipeMeta.vue